import { render, staticRenderFns } from "./priSettingsGoogleCustomSearchEngineUrl.vue?vue&type=template&id=18754606"
import script from "./priSettingsGoogleCustomSearchEngineUrl.vue?vue&type=script&lang=js"
export * from "./priSettingsGoogleCustomSearchEngineUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports